const CURRENT_ENV = process.env.APP_ENV || 'local'
const ADDITONAL_SETTINGS = require(`../../env/${CURRENT_ENV}_env`)

module.exports = ADDITONAL_SETTINGS.client
